document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('[data-runway-grid]');
  if (!grid) return;

  const items = Array.from(grid.querySelectorAll('[data-runway-item]'));
  const showAllBtn = grid.querySelector('[data-runway-showall]');
  const lightbox = document.querySelector('[data-runway-lightbox]');
  const lightboxImg = lightbox?.querySelector('[data-runway-lightbox-image]');
  const btnPrev = lightbox?.querySelector('[data-runway-prev]');
  const btnNext = lightbox?.querySelector('[data-runway-next]');
  const btnClose = lightbox?.querySelector('[data-runway-close]');

  let currentIndex = 0;
  const ITEMS_PER_ROW = 4;
  const MAX_ROWS = 4;
  const MAX_VISIBLE = ITEMS_PER_ROW * MAX_ROWS;

  /* ---------------------------
     GRID: SHOW ONLY 4 ROWS
  ---------------------------- */
  if (items.length > MAX_VISIBLE) {
    items.forEach((item, i) => {
      if (i >= MAX_VISIBLE) item.classList.add('is-hidden');
    });
    showAllBtn.hidden = false;
  }

  showAllBtn?.addEventListener('click', () => {
    items.forEach(item => item.classList.remove('is-hidden'));
    showAllBtn.hidden = true;
  });

  /* ---------------------------
     LIGHTBOX
  ---------------------------- */
  const openLightbox = (index) => {
    currentIndex = index;
    const img = items[currentIndex].querySelector('img');
    if (!img) return;

    // Load a higher-res source on demand for the lightbox (one image at a
    // time) rather than reusing a large grid bitmap. Falls back to the
    // grid's chosen candidate, then its src.
    lightboxImg.src = img.dataset.full || img.currentSrc || img.src;
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  const showNext = () => {
    currentIndex = (currentIndex + 1) % items.length;
    openLightbox(currentIndex);
  };

  const showPrev = () => {
    currentIndex = (currentIndex - 1 + items.length) % items.length;
    openLightbox(currentIndex);
  };

  items.forEach((item, index) => {
    item.addEventListener('click', () => openLightbox(index));
  });

  btnNext?.addEventListener('click', showNext);
  btnPrev?.addEventListener('click', showPrev);
  btnClose?.addEventListener('click', closeLightbox);

  lightbox?.addEventListener('click', (e) => {
    if (e.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', (e) => {
    if (lightbox.hidden) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowRight') showNext();
    if (e.key === 'ArrowLeft') showPrev();
  });
});
